import React from "react";
import axios from "axios";
import { History } from "lucide-react";
import { InboxList } from "./InboxList";
import { PageSizeSelect, ShowMoreButton, BulkDeleteButton } from "./ListControls";
import { usePageSize, usePagedList } from "../../utils/pagedList";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const DeliveryBadge = (n) => (
  <span className="text-xs px-2 py-0.5 rounded-full" data-testid={`push-history-badge-${n.id}`}
    style={{ background: n.sent ? "rgba(16,185,129,0.1)" : "rgba(107,114,128,0.1)", color: n.sent ? "#10b981" : "var(--rv-text-muted)" }}>
    {n.sent ? "Отправлено" : "Геолокация"}
  </span>
);

// Ж19/Ж22: технический журнал push-доставок на странице «Настройки уведомлений» — порции, удаление
export const PushHistoryBlock = () => {
  const [size, setSize] = usePageSize("rv_push_history_page_size");
  const list = usePagedList(`${API}/notifications/push-history`, size);

  const removeOne = async (n) => {
    if (!window.confirm("Удалить эту запись истории?")) return;
    try { await list.remove(n.id); } catch (e) { /* не критично */ }
  };

  const clearAll = async () => {
    if (!window.confirm("Очистить всю историю push-доставок?")) return;
    try { await axios.post(`${API}/notifications/push-history/clear`); await list.reload(); } catch (e) { /* не критично */ }
  };

  return (
    <div className="reversia-card p-6" data-testid="push-history-block">
      <div className="flex flex-wrap items-center gap-x-3 gap-y-2 mb-3">
        <h3 className="text-base font-semibold flex items-center gap-2 mr-auto" style={{ fontFamily: "Manrope,sans-serif", color: "var(--rv-text-primary)" }}>
          <History size={16} style={{ color: "var(--rv-teal)" }} />История push-доставок
          <span className="text-sm font-normal" style={{ color: "var(--rv-text-muted)" }} data-testid="push-history-total">всего: {list.total}</span>
        </h3>
        <PageSizeSelect value={size} onChange={setSize} testId="push-history-page-size" />
        <BulkDeleteButton label="Очистить историю" onClick={clearAll} disabled={!list.items.length} testId="push-history-clear" />
      </div>
      <div className="rounded-lg overflow-hidden" style={{ border: "1px solid var(--rv-border)" }}>
        <InboxList items={list.items} onDelete={removeOne} testPrefix="push-history" emptyText="У вас пока нет push-доставок" renderBadge={DeliveryBadge} />
        <ShowMoreButton shown={list.items.length} total={list.total} size={size} onClick={list.loadMore} testId="push-history-show-more" />
      </div>
    </div>
  );
};
